var _line, _line2, _line3, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDatenimport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "40px",
    height: "20px",
    viewBox: "0 0 40 20",
    enableBackground: "new 0 0 40 20",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    x1: 7.163,
    y1: 13,
    x2: 18.612,
    y2: 13
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    x1: 16.506,
    y1: 10.845,
    x2: 18.661,
    y2: 13
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    x1: 16.506,
    y1: 15.155,
    x2: 18.661,
    y2: 13
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    width: 40,
    height: 20
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_2_)",
    fill: "none",
    stroke: "#000000",
    strokeWidth: 1.32,
    d: "M12.913,1.66c0,0-0.33,0-0.33,0.33v16.02 c0,0,0,0.33,0.33,0.33h12.634c0,0,0.33,0,0.33-0.33V7.989c0,0,0-0.33-0.33-0.33h-5.433c0,0-0.33,0-0.33-0.33V1.99 c0,0,0-0.33-0.33-0.33H12.913z"
  }), /*#__PURE__*/React.createElement("line", {
    clipPath: "url(#SVGID_2_)",
    fill: "none",
    stroke: "#000000",
    strokeWidth: 1.32,
    strokeLinecap: "round",
    x1: 19.724,
    y1: 1.66,
    x2: 25.793,
    y2: 7.729
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDatenimport);
export default __webpack_public_path__ + "static/media/datenimport.d99cc8c471726e968a26e99af6b91dc3.svg";
export { ForwardRef as ReactComponent };